// material-ui
import PayhubTextLogo from './image/kidsview360textlogo.png'

const LogoIcon = () => {

  return (
    <img src={PayhubTextLogo} alt="insightCampLogo" width="200" />
  );
};

export default LogoIcon;